<template>
  <div class="container container-fluid">
    <div v-if="showComponentData">
      <div class="row">
        <!-- FRENTE DE CEDULA VERDE -->
        <div v-if="isFieldVisible('photo_green_card_front_file')" class="col-md-3 mt-3">
          <div>
            <div class="form-group bordered">
            <label for="photo_green_card_front_file" class="form-label text-left">{{ getFieldDescription('photo_green_card_front_file') }}</label>
          </div>
            <div>

              <div>
                <div @click="openCamera('photo_green_card_front_file')" class="btn btn-custom">
                  <i class="bi bi-camera-fill"></i> Tomar fotografía
                </div>
                <input
                  type="file"
                  accept="image/*"
                  capture="camera"
                  class="form-control inputfile"
                  :name="'photo_green_card_front_file'"
                  :id="'photo_green_card_front_file'"
                  style="display: none;"
                  @change="onFileChange('photo_green_card_front_file')"
                />
              </div>
            </div>
            <div class="btn tbn-block btn-custom mt-3" v-if="photo_green_card_front_file" @click="openImageModal(photo_green_card_front_file)">Ver Imagen</div>
          </div>
        </div>
        <!-- DORSO DE CEDULA VERDE -->
        <div v-if="isFieldVisible('photo_green_card_back_file')" class="col-md-3 mt-3">
          <div>
            <div class="form-group bordered">
            <label for="photo_green_card_back_file" class="form-label text-left">{{ getFieldDescription('photo_green_card_back_file') }}</label>
          </div>
            <div>
              <div>
                <div @click="openCamera('photo_green_card_back_file')" class="btn btn-custom">
                  <i class="bi bi-camera-fill"></i> Tomar fotografía
                </div>
                <input
                  type="file"
                  accept="image/*"
                  capture="camera"
                  class="form-control inputfile"
                  :name="'photo_green_card_back_file'"
                  :id="'photo_green_card_back_file'"
                  style="display: none;"
                  @change="onFileChange('photo_green_card_back_file')"
                />
              </div>
            </div>
            <div class="btn btn-block btn-custom mt-3" v-if="photo_green_card_back_file" @click="openImageModal(photo_green_card_back_file)">Ver Imagen</div>
          </div>
        </div>
        <!-- DORSO DE GNC -->
        <div v-if="isFieldVisible('photo_yellow_card_file')" class="col-md-3 mt-3">
          <div>
            <div class="form-group bordered">
            <label for="photo_yellow_card_file" class="form-label text-left">{{ getFieldDescription('photo_yellow_card_file') }}</label>
          </div>
            <div>
              <div>
                <div @click="openCamera('photo_yellow_card_file')" class="btn btn-custom">
                  <i class="bi bi-camera-fill"></i> Tomar fotografía
                </div>
                <input
                  type="file"
                  accept="image/*"
                  capture="camera"
                  class="form-control inputfile"
                  :name="'photo_yellow_card_file'"
                  :id="'photo_yellow_card_file'"
                  style="display: none;"
                  @change="onFileChange('photo_yellow_card_file')"
                />
              </div>
            </div>
            <div class="btn btn-block btn-custom mt-3" v-if="photo_yellow_card_file" @click="openImageModal(photo_yellow_card_file)">Ver Imagen</div>
          </div>
        </div>
        <!-- KILOMETRAJE EN EL TABLERO -->
        <div v-if="isFieldVisible('photo_general_vehicle_kms_file')" class="col-md-3 mt-3">
          <div>
            <div class="form-group bordered">
            <label for="photo_general_vehicle_kms_file" class="form-label text-left">{{ getFieldDescription('photo_general_vehicle_kms_file') }}</label>
          </div>
            <div>
              <div>
                <div @click="openCamera('photo_general_vehicle_kms_file')" class="btn btn-custom">
                  <i class="bi bi-camera-fill"></i> Tomar fotografía
                </div>
                <input
                  type="file"
                  accept="image/*"
                  capture="camera"
                  class="form-control inputfile"
                  :name="'photo_general_vehicle_kms_file'"
                  :id="'photo_general_vehicle_kms_file'"
                  style="display: none;"
                  @change="onFileChange('photo_general_vehicle_kms_file')"
                />
              </div>
            </div>
            <div class="btn btn-block btn-custom mt-3" v-if="photo_general_vehicle_kms_file" @click="openImageModal(photo_general_vehicle_kms_file)">Ver Imagen</div>
          </div>
        </div>
      </div>
      <hr class="custom-hr mt-4" />
    </div>
  </div>
    
  <!-- MODAL -->
  <ShowImagesModal
  :modalId="'imageModalPhotoGrenCard'"
  :currentImage="currentImage"
  :currentImageName="currentImageName"
  />
</template>

<script>
import { ref, onMounted } from 'vue';
import ShowImagesModal from '../../modals/ShowImages';
import ImageCompressor from 'image-compressor.js'; 
import { rotateImageIfNeeded } from '../../../Utils/imageUtils'; 

export default {
  name: 'FormPhotoGreenCard',
  props: {
    data: Object,
  },
  components: {
    ShowImagesModal,
  },
  emits: ['formDataChanged'],
  setup(props, { emit }) {
    const dataCompany = ref(props.data.dataCompaniesForms);
    const dataFormsField = ref(props.data.dataFormsField);
    const showComponentData = ref(false);
    const currentImage = ref(null);
    const currentImageName = ref('');

    const photo_green_card_front_file = ref(null);
    const photo_green_card_back_file = ref(null);
    const photo_yellow_card_file = ref(null);
    const photo_general_vehicle_kms_file = ref(null);

    const formData = ref({
      photo_green_card_front_id: null,
      photo_green_card_back_id: null,
      photo_yellow_card_id: null,
      photo_general_vehicle_kms_id: null,
    });

    const cargarDatos = () => {
      try {
        showComponentData.value = (
          dataCompany.value &&
          (dataCompany.value.photo_green_card_front_file ||
            dataCompany.value.photo_green_card_back_file ||
            dataCompany.value.photo_yellow_card_file ||
            dataCompany.value.photo_general_vehicle_kms_file)
        );
      } catch (error) {
        console.error(error);
      }
    };

    const isFieldVisible = (fieldName) => {
      return dataCompany.value && dataCompany.value[fieldName] === 1;
    };

    const getFieldDescription = (fieldNameLabel) => {
      let description = fieldNameLabel;
      const dataFormsFieldsWithData = Object.values(dataFormsField.value);
 
      dataFormsFieldsWithData[0].forEach((entry) => {
        const field = entry;
 
        if (field.name === fieldNameLabel) {
          description = field.description;
        }
      });
      return description;
    };

    const openImageModal = (imageFile) => {
      currentImage.value = URL.createObjectURL(imageFile);
      currentImageName.value = imageFile.name;
      $('#imageModalPhotoGrenCard').modal('show');
    };

    const onFileChange = async (fieldName) => {
      const fileFields = {
        photo_green_card_front_file: photo_green_card_front_file,
        photo_green_card_back_file: photo_green_card_back_file,
        photo_yellow_card_file: photo_yellow_card_file,
        photo_general_vehicle_kms_file: photo_general_vehicle_kms_file,
      };

      const fileInput = document.getElementById(fieldName);

      try {
        const rotatedFile = await rotateImageIfNeeded(fileInput.files[0], 90);
        const compressedFile = await compressImage(rotatedFile);
        fileFields[fieldName].value = compressedFile;
        emitFieldChanged();
      } catch (error) {
        console.error('Error al comprimir la imagen:', error);
      }
      };

      const compressImage = (file) => {
      return new Promise((resolve, reject) => {
        const compressor = new ImageCompressor();
        compressor.compress(file, {
          maxWidth: 800,
          maxHeight: 600,
          quality: 1,
          mimeType: 'image/jpeg',
          success(result) {
            resolve(result);
          },
          error(error) {
            reject(error);
          },
        });
      });
    };

    const emitFieldChanged = () => {
      const formFields = {
        photo_green_card_front_id: photo_green_card_front_file.value,
        photo_green_card_back_id: photo_green_card_back_file.value,
        photo_yellow_card_id: photo_yellow_card_file.value,
        photo_general_vehicle_kms_id: photo_general_vehicle_kms_file.value,
      };

      const validFields = {};
      for (const [key, value] of Object.entries(formFields)) {
        if (dataCompany.value && dataCompany.value[key.replace('_id', '_file')]) {
          validFields[key] = value;
        }
      }

      formData.value = validFields;
      emit('formDataChanged', formData.value);
    };

    const openCamera = async (fieldName) => {
      try {
        const inputElement = document.getElementById(fieldName);
        inputElement.click();
      } catch (error) {
        console.error('Error al abrir la ventana de selección de archivo:', error);
      }
    };

    onMounted(cargarDatos);

    return {
      dataCompany,
      showComponentData,
      isFieldVisible,
      getFieldDescription,
      dataFormsField,
      openImageModal,
      onFileChange,
      currentImage,
      currentImageName,
      emitFieldChanged,
      formData,
      photo_green_card_front_file,
      photo_green_card_back_file,
      photo_yellow_card_file,
      photo_general_vehicle_kms_file,
      openCamera,
    };
  },
};
</script>

